import React from "react";
import clsx from "clsx";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/styles";
import { Divider, Drawer, Grid } from "@material-ui/core";
import DashboardIcon from "@material-ui/icons/Dashboard";
import SettingsIcon from "@material-ui/icons/Settings";

import { SidebarNav, UpgradePlan } from "./components";
import { inshs, itmes } from "../../../../../Context/Local";
import LocalMallIcon from "@material-ui/icons/LocalMall";
import {
  Assessment,
  AssignmentReturn,
  Category,
  Collections,
  Directions,
  MoveToInbox,
  Receipt,
} from "@material-ui/icons";
import { sto } from "../../../../../Context/InshData";
import SelectLanguage from "../../../../../components/SelectLanguage";
const useStyles = makeStyles((theme) => ({
  drawer: {
    width: 240,
    [theme.breakpoints.up("lg")]: {
      marginTop: 54,
      height: "calc(100% - 54px)",
    },
  },
  root: {
    backgroundColor: theme.palette.white,
    display: "flex",
    flexDirection: "column",
    height: "100%",
    padding: theme.spacing(2),
  },
  divider: {
    margin: theme.spacing(2, 0),
  },
  nav: {
    marginBottom: theme.spacing(2),
  },
}));

const Sidebar = (props) => {
  const { open, variant, onClose, className, ...rest } = props;

  const classes = useStyles();

  const pages = [
    {
      title: "Dashboard",
      href: "",
      icon: <DashboardIcon />,
    },
    {
      title: "فاتورة مبيعات",
      href: "Invoices",
      icon: <LocalMallIcon />,
      insh: inshs.Sales.sal,
      isAllow: sto.used_Nsale_screen,
    },
    {
      title: "مرتجع مبيعات",
      href: "Invoices",
      icon: <AssignmentReturn />,
      insh: inshs.Sales.salRet,
      isAllow: sto.used_Rsale_screen,
    },
    {
      title: " شاشة الاصناف",
      href: "products",
      icon: <Collections />,
      insh: itmes,
      isAllow: sto.used_Items_screen,
    },
    {
      title: "تقرير الحركة اليومية",
      href: "ReporteveryDay",
      icon: <Assessment />,
      insh: "",
      isAllow: sto.used_Dialy_screen,
    },
    {
      title: "تقرير اقفال الوردية",
      href: "Shifts",
      icon: <Assessment />,
      insh: "",
      isAllow:sto.used_shifts_transClose??sto.used_Dialy_screen
    },
    {
      title: "تقرير كشف الحساب",
      href: "HesabCustA",
      icon: <Assessment />,
      insh: inshs.Customers[2],
      isAllow: sto.used_Accnt_screen,
    },
    {
      title: "تقرير كشف جرد المخازن",
      href: "ReportSafesJard",
      icon: <Assessment />,
      insh: "",
      isAllow: sto.used_Jarde_screen,
    },
    {
      title: " سند قبض خارجي",
      href: "ext-receipt",
      icon: <MoveToInbox />,
      insh: "",
      isAllow: sto.used_Sqabd_screen,
    },
    {
      title: "سند صرف خارجي",
      href: "ext-exchange",
      icon: <Directions />,
      insh: "",
      isAllow: sto.used_SSarf_screen,
    },
    // {
    //   title: "سند قبض داخلي",
    //   href: "int-receipt",
    //   icon: <MoveToInbox />,
    //   insh: "",
    //   isAllow: sto.used_Sqabd_screen,
    // },
    {
      title: "سند صرف داخلي",
      href: "int-exchange",
      icon: <Directions />,
      insh: "",
      isAllow: sto.used_SSarf_screen,
    },
    {
      title: "فاتورة مشتريات",
      href: "Invoices",
      icon: <LocalMallIcon />,
      insh: inshs.Purches.purch,
    isAllow: sto.used_purch_screen,

    },
    {
      title: "مرتجع مشتريات",
      href: "Invoices",
      icon: <Collections />,
      insh: inshs.Purches.purchRet,
    isAllow: sto.used_Rpurch_screen,

    },
    {
      title: "فاتورة عرض سعر",
      href: "Invoices",
      icon: <Receipt />,
      insh: inshs.Sales.salViw,

      isAllow: sto.used_Nsale_screen,
    },
    {
      title: "توريد مخزني",
      href: "store-supp",
      icon: <Receipt />,
      insh:"",
      isAllow: sto?.used_twreed_makhzni_screen??false,
    },
    {
      title: "صرف مخزني",
      href:  "store-exch",
      icon: <Receipt />,
      insh:"",
      isAllow: sto?.used_sarfe_mkhzni_screen??false,
    },
    {
      title: " تسوية مخزون",
      href:"reStore",
      icon: <Receipt />,
      insh:"",
      isAllow: sto?.used_tasweay_mkhzni_screen??false,
    },
    {
      title: "استلام مخزني",
      href:"ReceiveST",
      icon: <Receipt />,
      insh:"",
      isAllow: sto?.used_estlam_mkhzni_screen??false,
    },
    {
      title: "تقرير حركة صنف محدد",
      href:"curr-details-rpt",
      icon: <Receipt />,
      insh:"",
      isAllow: sto?.used_Treas_screen??false,
    },
    {
      title: "Settings",
      href: "settings",
      icon: <SettingsIcon />,
      isAllow: true,
    },

  ];

  return (
    <Drawer
      anchor="right"
      classes={{ paper: classes.drawer }}
      onClose={onClose}
      open={open}
      variant={variant}
    >
      <div {...rest} className={clsx(classes.root, className)}>
        {/* <Divider className={classes.divider} /> */}
        <SidebarNav className={classes.nav} pages={pages} />

        {/* <UpgradePlan /> */}
      </div>
      <Grid container ex={12} justify="center">
        <SelectLanguage />
      </Grid>
    </Drawer>
  );
};

Sidebar.propTypes = {
  className: PropTypes.string,
  onClose: PropTypes.func,
  open: PropTypes.bool.isRequired,
  variant: PropTypes.string.isRequired,
};

export default Sidebar;
